import { Spinner } from '@trello/nachos/spinner';

import { IslandNav } from 'app/src/components/IslandNav';

// eslint-disable-next-line @trello/less-matches-component
import * as styles from './BulkActionIsland.module.less';

export const BulkActionLoadingIsland = () => {
  return (
    <IslandNav
      buttonGroupClassName={styles.buttonGroup}
      className={styles.bulkActionIsland}
    >
      <Spinner isAi />
    </IslandNav>
  );
};
